import { LoadableAfterPaint } from '@confluence/loadable';

export const ViewPdfMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPdfMacro" */ '../src/ViewPdfMacroRenderer.tsx'
			)
		).ViewPdfMacroRenderer,
});
